import { useState } from "react";
import { Link } from "react-router-dom";
import Primero from "../img/primero.jpg";
import Segundo from "../img/segundo.jpg";
import Tercero from "../img/tercero.jpg";
import Cuarto from "../img/cuarto.jpg";
import Quinto from "../img/quinto.jpg";
import Sexto from "../img/sexto.jpg";
import PrimerGrado from "../img/primergrado.png";
import SegundoGrado from "../img/segundogrado.png";
import TercerGrado from "../img/tercergrado.png";
import Estudiantes from "../img/estudiantes.png";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Laminas from "../img/laminas.jpeg";
import Folleto from "../img/folleto.png";
import ModalForm from "../components/ModalForm";
import ModalDownload from "../components/ModalDownload";
import OptionButton from "../components/OptionButton";
import Cookies from "js-cookie";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

function Home() {
  const [showForm, setShowForm] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [formComplete, setFormComplete] = useState(
    Cookies.get("form-complete")
  );
  const [currentHref, setCurrentHref] = useState(null);
  const [currentDownloadResource, setCurrentDownloadResource] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const handleCloseForm = (href, downloadResource, image, validated) => {
    setShowForm(false);
    if (validated) {
      setCurrentHref(href);
      setCurrentDownloadResource(downloadResource);
      setCurrentImage(image);
      setShowDownload(true);
      Cookies.set("form-complete", true);
      setFormComplete(true);
    }
  };
  const handleCloseDownload = () => setShowDownload(false);
  const openModalForm = (href, resource, image) => {
    setCurrentHref(href);
    setCurrentDownloadResource(resource);
    setCurrentImage(image);
    setShowForm(true);
  };
  return (
    <div className="">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Libros Nuestro País</title>
        <meta property="og:title" content="Libros Nuestro País" />
        <meta
          name="description"
          content="Estos materiales didácticos, elaborados por el IEP, en alianza con la Fundación Mohme y el Jurado Nacional de Elecciones, son parte del “Proyecto Democracia: construyendo ciudadanía desde la escuela”."
        ></meta>
        <meta property="og:url" content={process.env.REACT_APP_URL} />
      </Helmet>

      <header className="header d-flex align-items-center p-2 pt-5 pt-md-2">
        <Container className="pt-5 pt-md-0">
          <Navbar />
          <Row className="align-items-center mt-5">
            <Col md={5} xs={12}>
              <h1>Nuestro País</h1>
              <p className="mt-5 mb-5">
                El propio entorno, el Perú como Estado y la diversidad son los
                tres temas que respectivamente aborda la serie de los libros
                “Nuestro país”. Estos materiales didácticos, elaborados por el
                IEP, en alianza con la Fundación Gustavo Mohme Llona y el Jurado
                Nacional de Elecciones, son parte del “Proyecto Democracia:
                construyendo ciudadanía desde la escuela”.
              </p>
              <div className="mb-2">
                <Button variant="outline-primary" href="#libros">
                  Descargar libros y fichas
                </Button>
              </div>
              <div>
                <Button variant="outline-primary" href="#libros-minedu">
                  Descargar adaptación MINEDU
                </Button>
              </div>
            </Col>
            <Col md={7} xs={12}>
              <img
                src={Estudiantes}
                alt="Estudiantes"
                className="img-fluid mt-5"
              />
            </Col>
          </Row>
        </Container>
      </header>
      <section id="libros">
        <Container className="my-5">
          <h2 class="my-5">Libros Nuestro País</h2>
          <Row className="text-center py-5">
            <Col md={4} sm={6} xs={12}>
              <img src={PrimerGrado} alt="Primer grado" width="240" />
              <h5 className="mt-3 mb-3 primero-color">Primer grado</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/03/Nuestro-Pais-1ro.pdf"
                downloadResource="Nuestro-Pais-1ro.pdf"
                image={PrimerGrado}
                openModalForm={openModalForm}
                className="btn-primero"
              />
              
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img src={SegundoGrado} alt="Segundo grado" width="240" />
              <h5 className="mt-3 mb-3 segundo-color">Segundo grado</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/03/Nuestro-Pais-2do.pdf"
                downloadResource="Nuestro-Pais-2do.pdf"
                image={SegundoGrado}
                openModalForm={openModalForm}
                className="btn-segundo"
              />
              
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img src={TercerGrado} alt="Tercer grado" width="240" />
              <h5 className="mt-3 mb-3 tercero-color">Tercer grado</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/03/Nuestro-Pais-3ro.pdf"
                downloadResource="Nuestro-Pais-3ro.pdf"
                image={TercerGrado}
                openModalForm={openModalForm}
                className="btn-tercero"
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section id="libros-minedu" class="bg-light">
        <Container className="py-5">
          <h2 className="my-5">Adaptación MINEDU</h2>
          <p>
            La Fundación Gustavo Mohme Llona puso a disposición del Ministerio
            de Educación (MINEDU) la colección de libros "Nuestro País",
            elaborada en el marco del{" "}
            <em>
              Proyecto Democracia: Construyendo ciudadanía desde la escuela
            </em>
            . Estos cuadernos de trabajo han venido siendo usados por un
            conjunto de escuelas públicas en las regiones de Ayacucho,
            Lambayeque, Lima y Piura.
          </p>
          <p>
            El año 2019, a solicitud del MINEDU, nuestros libros fueron
            adaptados por los especialistas del ministerio con la finalidad de
            atender a los estudiantes de 1º a 6° grado de primaria y, con ello,
            garantizar los aprendizajes en ciudadanía. El presente año escolar,
            vemos con satisfacción que los cuadernos de trabajo, producto de un
            esfuerzo conjunto, llegan a manos de todos los escolares de nuestro
            país. Agradecemos al Ministerio de Educación la confianza depositada
            en nuestro trabajo y ponemos a disposición estos materiales en la
            página web.
          </p>
          <br />
          <div className="mt-5">
            <Row className="text-center">
              <Col md={4} sm={6} xs={12}>
                <img src={Primero} alt="Primer grado" width="240" />
                <h5 className="mt-4 mb-2">Primer grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-1ro-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-1ro-Alta.pdf"
                  image={Primero}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
              <Col md={4} sm={6} xs={12}>
                <img src={Segundo} alt="Segundo grado" width="240" />
                <h5 className="mt-4 mb-2">Segundo grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-2do-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-2do-Alta.pdf"
                  image={Segundo}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
              <Col md={4} sm={6} xs={12}>
                <img src={Tercero} alt="Tercer grado" width="240" />
                <h5 className="mt-4 mb-2">Tercer grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-3ro-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-3ro-Alta.pdf"
                  image={Tercero}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
              <Col md={4} sm={6} xs={12}>
                <img src={Cuarto} alt="Cuarto grado" width="240" />
                <h5 className="mt-4 mb-2">Cuarto grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-4to-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-4to-Alta.pdf"
                  image={Cuarto}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
              <Col md={4} sm={6} xs={12}>
                <img src={Quinto} alt="Quinto grado" width="240" />
                <h5 className="mt-4 mb-2">Quinto grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-5to-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-5to-Alta.pdf"
                  image={Quinto}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
              <Col md={4} sm={6} xs={12}>
                <img src={Sexto} alt="Sexto grado" width="240" />
                <h5 className="mt-4 mb-2">Sexto grado</h5>
                <OptionButton
                  formComplete={formComplete}
                  href="https://fundacionmohme.org/wp-content/uploads/2021/04/Interiores-Nuestro-Pais-6to-Alta.pdf"
                  downloadResource="Interiores-Nuestro-Pais-6to-Alta.pdf"
                  image={Sexto}
                  openModalForm={openModalForm}
                  className="mb-5"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section id="fichas" className="">
        
        <Container className="p-5">
          
        <h2 class="my-5">Fichas Nuestro País</h2>
        <Row className="my-5">
          <Col md={6} sm={12} xs={12}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/58hn62Il-QA"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Col>
          <Col md={6} sm={12} xs={12}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/6SDm-zbmduc"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Col>
        </Row>
          <Row className="text-center py-5">
            <Col md={4} sm={6} xs={12}>
              <img src={PrimerGrado} alt="Primer grado" width="240" />
              <h5 className="mt-3 mb-3 primero-color">Primer grado</h5>
              <Link to="/primer-grado">
                <Button
                  variant="outline-primary"
                  className="btn-primero download-button btn-sm ml-2"
                >
                  Descargar fichas
                </Button>
              </Link>
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img src={SegundoGrado} alt="Segundo grado" width="240" />
              <h5 className="mt-3 mb-3 segundo-color">Segundo grado</h5>
              <Link to="/segundo-grado">
                <Button
                  variant="outline-primary"
                  className="btn-segundo download-button btn-sm ml-2"
                >
                  Descargar fichas
                </Button>
              </Link>
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img src={TercerGrado} alt="Tercer grado" width="240" />
              <h5 className="mt-3 mb-3 tercero-color">Tercer grado</h5>
              <Link to="/tercer-grado">
                <Button
                  variant="outline-primary"
                  className="btn-tercero download-button btn-sm ml-2"
                >
                  Descargar fichas
                </Button>
              </Link>
            </Col>
          </Row>
        
        </Container>
      </section>
      <section id="recursos">
        <Container className="p-5">
          <h2 className="my-5">Recursos educativos</h2>
          <Row>
            <Col md={6} xs={12}>
              <div className="img-recursos">
                <img src={Laminas} alt="Ciudadanía activa" />
              </div>
              <h6 className="my-3">Laminas: Ciudadanía activa</h6>

              <Button
                variant="outline-primary"
                href="https://fundacionmohme.org/especiales/ciudadania-activa/"
                target="_blank"
                rel="noreferrer"
                className="mb-5"
              >
                Descargar
              </Button>
            </Col>
            <Col md={6} xs={12}>
              <div className="img-recursos">
                <img src={Folleto} alt="Ciudadanía activa" />
              </div>
              <h6 className="my-3">
                Folleto “Docentes y directivos: el reto de la ciudadanía plena”
              </h6>
              <Button
                variant="outline-primary"
                href="https://fundacionmohme.org/recursos/folleto-docentes-y-directivos-el-reto-de-la-ciudadania-plena/"
                target="_blank"
                rel="noreferrer"
                className="mb-5"
              >
                Descargar
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
     

      <section id="webinars" className="bg-light">
        <Container className="p-5">
          <h2 className="mb-5 mt-0S">
            Ciclo de webinars "Aprendizajes ciudadanos para la escuela"
          </h2>
          <Row>
            <Col md={6} xs={12}>
              <div className="video-container">
                <iframe
                  src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FFundacionMohme%2Fvideos%2F4156946130991582%2F&show_text=false&width=560&t=0"
                  scrolling="no"
                  frameBorder="0"
                  title="video 1"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                ></iframe>
              </div>
            </Col>
            <Col md={6} xs={12}>
              <div className="video-container">
                <iframe
                  src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FFundacionMohme%2Fvideos%2F802142200406287%2F&show_text=false&width=560"
                  scrolling="no"
                  frameBorder="0"
                  title="video 2"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                ></iframe>
              </div>
            </Col>
            <Col md={6} xs={12}>
              <div className="video-container">
                <iframe
                  src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FFundacionMohme%2Fvideos%2F2605985469702249%2F&show_text=false&width=560&t=0"
                  scrolling="no"
                  frameBorder="0"
                  title="video 3"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                ></iframe>
              </div>
            </Col>
            <Col md={6} xs={12}>
              <div className="video-container">
                <iframe
                  src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FFundacionMohme%2Fvideos%2F538428637428550%2F&show_text=false&width=560&t=0"
                  scrolling="no"
                  frameBorder="0"
                  title="video 4"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="proyecto-democracia">
        <Container className="p-5">
          <Row>
            <Col md={6} xs={12}>
              <small>Sobre el proyecto</small>
              <h2 className="mb-3">
                Proyecto democracia: construyendo ciudadanía desde la escuela
              </h2>
              <p className="mb-5">
                Busca contribuir a formar ciudadanos y ciudadanas con valores
                éticos, democráticos y comprometidos con el desarrollo del país.
              </p>
              <Button
                variant="outline-primary"
                href="https://fundacionmohme.org/proyecto-democracia/"
                target="_blank"
                rel="noreferrer"
                className="mb-5"
              >
                Conoce más sobre el proyecto
              </Button>
            </Col>
            <Col md={6} xs={12}>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/noGl7MTWBDQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
      <ModalForm
        show={showForm}
        handleClose={handleCloseForm}
        href={currentHref}
        image={currentImage}
        downloadResource={currentDownloadResource}
      />
      <ModalDownload
        show={showDownload}
        handleClose={handleCloseDownload}
        href={currentHref}
        downloadResource={currentDownloadResource}
        image={currentImage}
      />
    </div>
  );
}

export default Home;
